import { useCallback, memo } from 'react'
import { PermissionGuard } from '@/app/router/guards'
import { trackEvent } from '@/lib/analytics'
import { trackFunnel } from '@/lib/funnel'
import { PERMISSIONS } from '@/lib/permissions'
import { GROWTH_PLAN_STRIPE_GENERATED_PAYMENT_ID } from '@/lib/prices'
import { Button } from '@/components/catalyst-ui/button'
import { ArrowUpRightIcon } from '@heroicons/react/20/solid'

export const GrowthPlanPromoCard = memo(function GrowthPlanPromoCard({
  className = '',
  workspaceId = 'default',
}) {
  const handleGrowthPlanUpgrade = useCallback(() => {
    // Journeys `pricing_promo_clicked`, fired before the existing logic (which is unchanged).
    trackFunnel('pricing_promo_clicked', { props: { promo: 'growth_sidebar', plan: 'Growth' } })
    const targetWorkspace = workspaceId || 'default'
    trackEvent('Pricing:SidebarPromoCardCTAClicked', {
      plan: 'Growth',
      source: 'workspace_sidebar_ai_credits_card',
      workspaceId: targetWorkspace,
    })

    const growthPlanUrl = new URL('/pricing', window.location.origin)
    growthPlanUrl.searchParams.set('workspace', targetWorkspace)
    growthPlanUrl.searchParams.set('paymentId', GROWTH_PLAN_STRIPE_GENERATED_PAYMENT_ID)
    growthPlanUrl.searchParams.set('feature', 'sidebar_growth_promo')
    window.open(growthPlanUrl.toString(), '_blank', 'noopener,noreferrer')
  }, [workspaceId])

  return (
    <div className={className}>
      <div
        className="bg-white hover:bg-gray-50 rounded-2xl p-3 border border-[#E4E4E7] my-2
cursor-pointer"
        onClick={handleGrowthPlanUpgrade}
      >
        <div className="">
          <div className="flex flex-wrap gap-2 mb-2">
            <div className="flex min-w-0 items-start gap-2">
              <h3 className="pt-0.5 text-sm font-semibold leading-5 text-[#18181B]">
                Launch more with Growth
              </h3>
            </div>
            <div className="shrink-0 text-right leading-none flex items-baseline">
              <div className="flex items-baseline justify-end gap-0.5 text-[#18181B]">
                <span className="text-sm font-semibold">$</span>
                <span className="text-2xl font-bold leading-[21.6px]">29</span>
              </div>
              <div className="mt-1 text-sm font-semibold text-[#52525B]">/mo</div>
            </div>
          </div>
          <p className="text-xs font-medium leading-5 text-[#71717A] mb-3">
          Get the workspace you need to build and publish more websites.
          </p>
          {/* <div className="mb-4 space-y-1.5 text-xs font-medium text-[#52525B]">
            <div className="flex items-center gap-2">
              <span className="inline-block size-1.5 shrink-0 rounded-full bg-[#5C33FF]" />
              <span>AI-powered edits for your workspace</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="inline-block size-1.5 shrink-0 rounded-full bg-[#5C33FF]" />
              <span>More room to create and iterate</span>
            </div>
          </div> */}
          <PermissionGuard permission={PERMISSIONS.UPGRADE_NOW}>
            <Button
              plain
              className=" !text-white !hidden lg:!inline-flex items-center !px-4 !bg-[#5C33FF] hover:!bg-[#5C33FF]/90 !rounded-lg !text-sm !font-semibold !shadow-[0px_2px_0px_0px_#FFFFFF26_inset] data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 w-full"
            >
              Upgrade Now
              {/* <ArrowUpRightIcon className="w-4 h-4 !text-white !ml-auto" /> */}
            </Button>
          </PermissionGuard>
        </div>
      </div>
    </div>
  )
})
